import { render, staticRenderFns } from "./purchased.vue?vue&type=template&id=5e0d6526&scoped=true&"
import script from "./purchased.vue?vue&type=script&lang=js&"
export * from "./purchased.vue?vue&type=script&lang=js&"
import style0 from "./purchased.vue?vue&type=style&index=0&id=5e0d6526&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d6526",
  null
  
)

export default component.exports